import { NotificationBarAction, NotificationBarActionKeys, BarType, NotificationArguments } from './actions';

export interface Notification {
	date: Date;
	message: string;
	args?: NotificationArguments;
	barType: BarType;
}

export interface NotificationBarState {
	history: Notification[];
}

const initialState: NotificationBarState = {
	history: []
};

export function notificationBar(
	state: NotificationBarState = initialState,
	action: NotificationBarAction
): NotificationBarState {
	let newHistory;
	switch (action.type) {
		case NotificationBarActionKeys.CREATE_NOTIFICATION:
			newHistory = [...state.history, {
				date: new Date(),
				message: action.message,
				barType: action.barType,
				args: action.args
			}];
			break;
		case NotificationBarActionKeys.CLEAR_NOTIFICATIONS:
			newHistory = [];
			break;
		default:
			return state;
	}

	return { ...state, history: newHistory };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/NotificationBar/reducer.ts